export const getFormattedCrewString = (crewArray: string[]) => {
    if (crewArray.length > 1)
        return `${crewArray.slice(0, -1).join(', ')}, ${crewArray.slice(-1)}`;
    return crewArray[0];
};
